import { render, staticRenderFns } from "./CardCover.vue?vue&type=template&id=0cccbb6d&scoped=true"
import script from "./CardCover.vue?vue&type=script&lang=js"
export * from "./CardCover.vue?vue&type=script&lang=js"
import style0 from "./CardCover.vue?vue&type=style&index=0&id=0cccbb6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cccbb6d",
  null
  
)

export default component.exports